import { Camera, CameraPermissionState } from '@capacitor/camera';
import { isPlatform } from '@ionic/vue';
import { captureException } from '@sentry/vue';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const usePhotoGalleryPermission = defineStore('photo-permission', () => {
  const status = ref<CameraPermissionState>('prompt');
  const isTurnedOn = ref(true);

  const shouldPrompt = computed(() => status.value === 'prompt' || status.value === 'prompt-with-rationale');
  const ready = computed(() => (status.value === 'granted' || status.value === 'limited') && isTurnedOn.value);

  async function onAppResume() {
    if (!isPlatform('hybrid')) {
      status.value = 'granted';
      isTurnedOn.value = true;
      return;
    }

    try {
      console.log('Checking Photo Permissions...');
      const permissions = await Camera.checkPermissions();
      console.log('Checked Photo Permissions', permissions.photos);
      isTurnedOn.value = true;
      status.value = permissions.photos;
    } catch (e) {
      console.error('Error checking photo permissions', e);
      isTurnedOn.value = false;
      captureException(e);
    }
  }

  async function prompt() {
    if (!shouldPrompt.value) {
      return;
    }
    try {
      console.log('Requesting photos permissions...');
      const permissions = await Camera.requestPermissions({ permissions: ['photos'] });
      console.log('Requested Photo Permissions', permissions.photos);
      isTurnedOn.value = true;
      status.value = permissions.photos;
    } catch (e) {
      console.error('Error requesting photo permissions', e);
      isTurnedOn.value = false;
      captureException(e);
    }
  }

  return {
    ready,
    onAppResume,
    prompt,
  };
});
